.item {
  display: flex;
  align-items: flex-start;
  text-align: left;
  justify-content: space-between;
  padding: 8px 8px;
  border-radius: 8px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &__content {
    min-width: 0;
  }

  &__desc {
    margin: 0 0 0 28px;
    font-size: 11px;
    color: #6b7280;
    line-height: 1.4;
  }
}